import api from '../api';

export interface SolicitacaoAlteracaoSensivelCandidato {
  id: string;
  processoId: string;
  processoIdentificador?: string;
  candidatoId: string;
  candidatoNome?: string;
  inscricoesEditais?: string[];
  solicitanteId: string;
  solicitanteNome?: string;
  aprovadorId?: string;
  tipo: 'ALTERAR_STATUS' | 'DELETAR';
  status: 'PENDENTE' | 'APROVADO' | 'REJEITADO';
  statusAtual: string;
  statusSolicitado?: string;
  justificativa?: string;
  jiraTicket: string;
  motivoDecisao?: string;
  dataCriacao: string;
  dataAtualizacao?: string;
}

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
  first: boolean;
  last: boolean;
}

export default class CandidatoSolicitacaoSensivelViewModel {
  static async listarPendentes(page: number = 0, size: number = 10): Promise<PaginatedResponse<SolicitacaoAlteracaoSensivelCandidato>> {
    const response = await api.get('/candidatos/alteracoes-sensiveis/solicitacoes', {
      params: { status: 'PENDENTE', page, size }
    });
    return response.data;
  }

  static async contarPendentes(): Promise<number> {
    const response = await api.get('/candidatos/alteracoes-sensiveis/solicitacoes', {
      params: { status: 'PENDENTE', page: 0, size: 1 }
    });
    return response.data?.totalElements || 0;
  }

  static async aprovar(id: string): Promise<void> {
    await api.post(`/candidatos/alteracoes-sensiveis/solicitacoes/${id}/aprovar`);
  }

  static async rejeitar(id: string, motivo: string): Promise<void> {
    await api.post(`/candidatos/alteracoes-sensiveis/solicitacoes/${id}/rejeitar`, { motivo });
  }
}
